export default __webpack_public_path__ + "static/media/IBMPlexMono-Regular-Latin3.cacfd1d7.woff2";